import React from 'react';

import Base64Image from '../../../lib/components/Base64Image';
import I18n from '../../../lib/i18n';
import { IUnpackedRelatedChannel } from '../../../models/MessagePreview/UnpackedRelatedChannel';
import NewsText from './NewsText';

interface IProps {
  relatedChannel: IUnpackedRelatedChannel;
}

const DiscoveryRelatedChannel = (props: IProps) => {
  const { relatedChannel } = props;

  return (
    <div className="discovery-related-channel">
      <div className="discovery-related-channel-title">
        <span className="discovery-related-channel-title-text">{I18n.t('messages.preview.discovery_related_channel_list_header')}</span>
      </div>
      <div>
        <div className="discovery-related-channel-card">
          <div className="discovery-related-channel-image-area">
            <Base64Image className="discovery-related-channel-image" image={relatedChannel.topic_image} />
          </div>
          <div className="discovery-related-channel-text">
            <NewsText className="discovery-related-channel-name" text={relatedChannel.topic_name} />
            <NewsText className="discovery-related-channel-publisher" text={relatedChannel.topic_publisher} />
          </div>
          <div className="discovery-related-channel-subscribe">
            <div>
              <div className="discovery-related-channel-subscribe-icon"></div>
            </div>
            <div>{I18n.t('messages.preview.not_subscribed')}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscoveryRelatedChannel;
